import React, { useState, useEffect } from 'react'
import { ButtonGroup, Col, Icon, Panel, Row, Table, Uploader } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { downloadFileByPath, saveAttachmentPapertype } from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import { isEmpty } from 'lodash-es'
import TooltipButton from '../../components/buttons/TooltipButton'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isImageOrPdf, isValidators } from '../../utils/ValidatorUtils'
import { downloadFile, previewFile } from '../../utils/fileUtil'

export default function AttachFilesPaperTypeForm(props) {
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const { theme } = React.useContext(AppContext)

  const [formSchema, setFormSchema] = useState(props.schemaAttachFiles)
  const [formSchemaAtt, setFormSchemaAtt] = useState(props.buttonAtt)
  const [isEdit, setIsEdit] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const projectId = sessionStorage.getItem('projectId')

  console.log('gooo => ', props.contractChangeId)

  const onSubmitAttachFilesPaperType = async (data) => {
    // console.log('onSubmitAttachFilesPaperType => ', data)

    // return false

    startLoading()
    setIsLoading(true)
    try {
      const formData = new FormData()

      data.attachFilesPaperType &&
        data.attachFilesPaperType?.forEach((element) => {
          formData.append('Files', element.blobFile)
        })

      let response = await saveAttachmentPapertype(formData, projectId, props.contractChangeId)
      console.log('response', response)

      if (response?.success) {
        setFormSchema(response.model.attachFilesPaperType)
        setValue(formSchema.name, null)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        location.reload()
      } else {
        notification.open('error', {
          title: response?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadPreviewFile = async (fileObj, type) => {
    console.log('handleDownloadPreviewFile ', fileObj, type)

    startLoading()
    setIsLoading(true)
    try {
      var file = await downloadFileByPath(fileObj.path)
      var fileName = fileObj.name

      if ('download' == type) {
        downloadFile(file, fileName)
      } else if ('preview' == type) {
        previewFile(file, fileName)
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema?.header || ''}
        collapsible
        defaultExpanded
        style={{ marginTop: 15 }}
      >
        {formSchema?.disable && (
          <div>
            <div style={{ marginBottom: 5 }}>
              <ErrorMessage error={errors.attachFilesPaperType} />
            </div>
            <Controller
              name={formSchema.name}
              control={control}
              defaultValue={undefined}
              rules={isValidators(formSchema.validators)}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.fileType || '.jpg, .jpeg, .png, .pdf'}
                    draggable
                    autoUpload={false}
                    multiple={false}
                    fileList={props.value || []}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let files = []
                        let file = fileList[fileList.length - 1]

                        if (file.blobFile.size > formSchema?.fileSize * 1024 * 1024) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          files.push(fileList[fileList.length - 1])
                          props.onChange(files)
                        } else {
                          notification.open('error', {
                            title: `ชนิดที่รองรับ ${
                              formSchema.fileType || '.jpg, .jpeg, .png, .pdf'
                            }`,
                            duration: 5000,
                          })
                        }
                      }
                    }}
                  >
                    <div>
                      <div
                        style={{ lineHeight: '50px' }}
                        className={classNames('uploader', `${theme[0]}-background`)}
                      >
                        <Icon size="4x" icon="upload2" />
                        <small className="uploder__text">
                          <p style={{ wordBreak: 'break-word' }}>
                            คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                          </p>
                        </small>
                      </div>
                    </div>
                  </Uploader>
                )
              }}
            />
          </div>
        )}

        <div>
          <table border={1} width={'100%'}>
            <tr>
              <th style={{ width: '10%' }}>
                <p style={{ padding: 5 }}>ลำดับ</p>
              </th>
              <th>
                <p style={{ padding: 5 }}>ชื่อไฟล์</p>
              </th>
              <th style={{ width: '20%' }}>
                <p style={{ padding: 5 }}>#</p>
              </th>
            </tr>
            {formSchema?.values?.length > 0 ? (
              formSchema?.values?.map((item, index) => {
                return (
                  <tr>
                    <td>
                      <p style={{ padding: 5, textAlign: 'center' }}>{`${index + 1}.`}</p>
                    </td>
                    <td>
                      <p style={{ padding: 5 }}>{item.name}</p>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <ButtonGroup>
                        <TooltipButton
                          icon="eye"
                          tooltip={`แสดง`}
                          onClick={(e) => handleDownloadPreviewFile(item, 'preview')}
                        ></TooltipButton>
                        <TooltipButton
                          icon="download"
                          tooltip={`ดาวน์โหลด`}
                          onClick={(e) => handleDownloadPreviewFile(item, 'download')}
                        ></TooltipButton>
                      </ButtonGroup>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colspan="3">
                  <p style={{ padding: 5, textAlign: 'center' }}>...ไม่พบข้อมูล...</p>
                </td>
              </tr>
            )}
          </table>
        </div>

        {formSchemaAtt && (
          <div style={{ textAlign: 'right' }}>
            <hr />

            {formSchemaAtt?.attSave && formSchema?.disable && (
              <SaveButton onClick={handleSubmit(onSubmitAttachFilesPaperType)} disabled={isLoading}>
                {formSchemaAtt.attSave}
              </SaveButton>
            )}

            {/* {formSchemaAtt.attEdit && isEdit && (
              <EditButton
                onClick={() => {
                  setIsEdit(false)
                }}
                disabled={isLoading}
              >
                {formSchemaAtt.attEdit}
              </EditButton>
            )}

            {formSchemaAtt.attCancel && (
              <CancelButton
                onClick={() => {
                  setIsEdit(!isEdit)
                }}
              >
                {formSchemaAtt.attCancel}
              </CancelButton>
            )} */}
          </div>
        )}
      </Panel>
    </>
  )
}
